'use client'

import React, { ReactNode } from 'react'

import { useAmplitude } from '@Analytics/hook'
import { ProductDisplayDrawerTrigger } from '@Domains/Product/Features/Display/Drawer/Trigger'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductDescription.module.scss'

/** Shared interactive drawer around already-rendered description content. */
export const ProductDescriptionDrawer = ({ children, productID, productType }: { children: ReactNode, productID: string, productType?: string | null }) => {
  const { t } = useTranslation()
  const ampli = useAmplitude()
  return (
    <ProductDisplayDrawerTrigger
      onOpenChange={(open) => {
        if (open) {
          ampli.productDescriptionOpen({
            source_id: 'inherit',
          })
        }
      }}
      sourceID="product_description"
      title={t('products:DESCRIPTION')}
    >
      {children}

      {productType === 'piercings' && (
        <p>
          <strong>
            {t('products:PIERCINGS_ONLY_RETURNABLE_IN_UNOPENED_PACKAGING')}
          </strong>
        </p>
      )}

      {(productType === 'socks' || productType === 'boxers') && (
        <p>
          <strong>
            {t('products:PIERCINGS_ONLY_RETURNABLE_IN_UNOPENED_PACKAGING')}
          </strong>
        </p>
      )}

      <div className={styles.productId}>
        {`ID: ${productID}`}
      </div>
    </ProductDisplayDrawerTrigger>
  )
}
